// 수급 궤적 분석 — 국내 외국인+기관 순매수 vs 주가의 롤링Z 궤적. (Flows/trading flows.py 포팅)

function rollingZ(arr, window, minP = 5) {
  const out = new Array(arr.length).fill(NaN);
  for (let i = 0; i < arr.length; i++) {
    const s = Math.max(0, i - window + 1);
    const win = arr.slice(s, i + 1);
    if (win.length < minP) continue;
    const m = win.reduce((a, b) => a + b, 0) / win.length;
    const v = win.reduce((a, b) => a + (b - m) * (b - m), 0) / (win.length - 1);  // 표본 std
    const sd = Math.sqrt(v);
    if (sd > 0) out[i] = (arr[i] - m) / sd;
  }
  return out;
}

function splitN(arr, n) {
  const out = [], len = arr.length, base = Math.floor(len / n), rem = len % n;
  let idx = 0;
  for (let i = 0; i < n; i++) {
    const size = base + (i < rem ? 1 : 0);
    out.push(arr.slice(idx, idx + size));
    idx += size;
  }
  return out.filter(c => c.length);
}
const mean = a => a.reduce((x, y) => x + y, 0) / a.length;

export function quadrant(zs, zp) {
  if (zs > 0 && zp > 0) return { key: "momentum", label: "모멘텀 구간", desc: "수급·주가 모두 강세 — 추세 지속 여부 모니터링", color: "#c0392b" };
  if (zs > 0 && zp <= 0) return { key: "accum", label: "매집 가능 구간", desc: "수급 유입 대비 주가 미반응 — 선행 수급 주목", color: "#0a7c59" };
  if (zs <= 0 && zp > 0) return { key: "distrib", label: "분배 경고 구간", desc: "주가는 높으나 수급 이탈 중 — 리스크 관리", color: "#b8860b" };
  return { key: "slump", label: "침체 구간", desc: "수급·주가 모두 약세 — 바닥 확인 필요", color: "#666" };
}

// series: [{date, price, combined, foreign, inst}] (오름차순)
export function computeFlowTrajectory(series, window = 20, segments = 6) {
  if (!series || series.length < window + segments) return null;
  const zp = rollingZ(series.map(s => s.price), window);
  const zs = rollingZ(series.map(s => s.combined), window);
  const valid = [];
  for (let i = 0; i < series.length; i++) {
    if (Number.isFinite(zp[i]) && Number.isFinite(zs[i]))
      valid.push({ date: series[i].date, zs: zs[i], zp: zp[i] });
  }
  if (valid.length < segments) return null;
  const chunks = splitN(valid, segments);
  const pts = chunks.map((ch, i) => ({
    idx: i + 1,
    x: mean(ch.map(v => v.zs)),
    y: mean(ch.map(v => v.zp)),
    dateStart: ch[0].date,
    dateEnd: ch[ch.length - 1].date,
  }));
  const zsNow = valid[valid.length - 1].zs;
  const zpNow = valid[valid.length - 1].zp;
  const last = series[series.length - 1];
  return { pts, zsNow, zpNow, last, quadrant: quadrant(zsNow, zpNow), n: series.length };
}
